import React from "react";

const LoadingButton = ({
  onClick,
  loading,
  children,
  className = "",
  ...props
}) => {
  return (
    <button
      onClick={onClick}
      className={`relative flex justify-center h-[40px] items-center gap-2 px-4 py-2 rounded-lg ${className} ${
        loading ? "opacity-70 cursor-not-allowed" : ""
      }`}
      disabled={loading}
      {...props}
    >
      {loading ? (
        <svg
          className="h-5 w-5 text-black animate-spin"
          viewBox="0 0 50 50"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            className="stroke-current"
            cx="25"
            cy="25"
            r="20"
            fill="none"
            strokeWidth="5"
            strokeLinecap="round"
            strokeDasharray="90,150"
            strokeDashoffset="0"
          />
        </svg>
      ) : (
        children
      )}
    </button>
  );
};

export default LoadingButton;
